import { Field, useFormikContext } from "formik";
import { FormFieldWrapper } from "../../../../components/FormComponents/FieldWrapper";
import { TextField } from "@mui/material";
import { hasError } from "../../../../components/FormComponents/utils";
import { CustomErrorMessage } from "../../../../components/FormComponents/CustomErrorMessage";
import { useEffect } from "react";
import { IPeca } from "../../../Obras/newObra/IObra";



export function ValorSemIvaForm({pecasUpdatedIncrementer} : {pecasUpdatedIncrementer: number}) {

    const { errors, values, touched, setFieldValue } = useFormikContext<any>();


    useEffect(() => {
        console.log("Transporte updated: ", values.transporte);
        let newVal = values.pecasOrcamentadas?.reduce((prev: number, curr: Partial<IPeca>) => prev + (curr?.amount ? curr.amount : 0) * (curr?.unitPrice ? curr.unitPrice : 0), 0);
        if (values.transporte) {
            newVal += (values?.client?.distancia || 0) * 0.36
        }
        console.log("New val: ", newVal);
        setFieldValue('valueWithoutIVA', newVal);

    }, [values.pecasOrcamentadas?.length, values.transporte, values.client?.distancia, pecasUpdatedIncrementer])


    return (
        <FormFieldWrapper label={"Valor s/ IVA"}>
            <>
                <Field
                    className="w-full"
                    name="valueWithoutIVA"
                    as={TextField}
                    error={hasError({ errors, touched, name: 'valueWithoutIVA' })}
                    variant={'outlined'}
                    type={'number'}
                    label={'Valor s/ IVA'} />
                <CustomErrorMessage name={"valueWithoutIVA"} />
            </>
        </FormFieldWrapper>
    )


}